// extracted by mini-css-extract-plugin
export default {"label":"Label_label__Zz0X1","oneLineLabel":"Label_oneLineLabel__0Dj1Z"};